import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthModule } from '../../../auth/auth.module';
import { DeleteModalComponent } from './delete.modal.component';

@NgModule({
    declarations: [DeleteModalComponent],
    imports: [BrowserModule, AuthModule],
    exports: [DeleteModalComponent]
})

export class DeleteModalModule {}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/deletemodal/delete.modal.module.ts